/**
 * 营销活动模块路由
 * topNav: marketing
 */
export default {
  path: 'marketing',
  name: 'Marketing',
  component: () => import('@/layout/RouteView.vue'),
  meta: {
    title: '营销活动',
    titleKey: 'routes.marketing',
    topNav: 'marketing',
    icon: 'GiftOutlined',
  },
  children: [
    // 活动管理（分组）
    {
      path: 'activity-management',
      name: 'ActivityManagement',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '活动管理', titleKey: 'routes.activityManagement', icon: 'GiftOutlined' },
      children: [
        {
          path: 'activity-list',
          name: 'ActivityList',
          component: () => import('@/views/marketing/activity-management/activity-list/index.vue'),
          meta: {
            title: '活动列表',
            titleKey: 'routes.activityList',
            permission: 'activityList:view',
          },
        },
        // 创建活动
        {
          path: 'activity-list/add',
          name: 'ActivityAdd',
          component: () =>
            import('@/views/marketing/activity-management/activity-list/activity-add.vue'),
          meta: {
            title: '创建活动',
            titleKey: 'routes.activityAdd',
            permission: 'activityList:create',
            hidden: true,
          },
        },
        // 编辑活动
        {
          path: 'activity-list/edit/:id',
          name: 'ActivityEdit',
          component: () =>
            import('@/views/marketing/activity-management/activity-list/activity-add.vue'),
          meta: {
            title: '编辑活动',
            titleKey: 'routes.activityEdit',
            permission: 'activityList:update',
            hidden: true,
          },
        },
        // 活动详情
        {
          path: 'activity-list/detail/:id',
          name: 'ActivityDetail',
          component: () =>
            import('@/views/marketing/activity-management/activity-list/activity-detail.vue'),
          meta: {
            title: '活动详情',
            titleKey: 'routes.activityDetail',
            permission: 'activityListDetail:view',
            hidden: true,
          },
        },
        // 活动列表 — 按钮级权限
        {
          path: 'activity-list',
          name: 'ActivityListCreate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '添加活动', permission: 'activityList:create', hidden: true },
        },
        {
          path: 'activity-list',
          name: 'ActivityListUpdate',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '编辑活动', permission: 'activityList:update', hidden: true },
        },
        {
          path: 'activity-list',
          name: 'ActivityListDelete',
          component: () => import('@/layout/RouteView.vue'),
          meta: { title: '删除活动', permission: 'activityList:delete', hidden: true },
        },
        {
          path: 'draw-record',
          name: 'DrawRecord',
          component: () => import('@/views/marketing/activity-management/draw-record.vue'),
          meta: {
            title: '开奖记录',
            titleKey: 'routes.drawRecord',
            permission: 'activity:draw-record',
          },
        },
        {
          path: 'gift-claim-record',
          name: 'GiftClaimRecord',
          component: () => import('@/views/marketing/activity-management/gift-claim-record.vue'),
          meta: {
            title: '礼品领取记录',
            titleKey: 'routes.giftClaimRecord',
            permission: 'activity:gift-claim-record',
          },
        },
      ],
    },
    // 活动模板
    {
      path: 'activity-template',
      name: 'ActivityTemplate',
      component: () => import('@/layout/RouteView.vue'),
      meta: { title: '活动模板', titleKey: 'routes.activityTemplate', icon: 'AppstoreOutlined' },
      children: [
        {
          path: '',
          name: 'ActivityTemplateList',
          component: () => import('@/views/marketing/activity-template/index.vue'),
          meta: {
            title: '活动模板',
            titleKey: 'routes.activityTemplate',
            permission: 'activity:template-list',
          },
        },
        {
          path: 'editor/:templateId?',
          name: 'ActivityTemplateEditor',
          component: () => import('@/views/marketing/activity-template/editor.vue'),
          meta: {
            title: '模板编辑器',
            titleKey: 'routes.activityTemplateEditor',
            hidden: true,
            contentPlain: true,
            contentFull: true,
            permission: 'activity:template-list',
          },
        },
      ],
    },
    // 营销数据（直接页面，无子级）
    {
      path: 'marketing-data',
      name: 'MarketingData',
      component: () => import('@/views/marketing/marketing-data/index.vue'),
      meta: {
        title: '营销数据',
        titleKey: 'routes.marketingData',
        permission: 'marketing:data',
        icon: 'BarChartOutlined',
      },
    },
  ],
};
